﻿'use strict';

/**
* Controller for the header
* @memberOf components.headerModule
* @namespace headerController
*/

headerController.$inject = ['sessionManagementFactory', 'authorizationFactory'];

function headerController(sessionManagementFactory, authorizationFactory) {
    /* jshint validthis:true */
    var vm = this;
    vm.title = 'headerController';

    vm.currentDate = new Date();

    /**
   * Gets current date
   * @method getCurrentDate
   * @returns {Object} current date object
   * @memberOf components.headerModule.headerController
   */
    vm.getCurrentDate = function () { return vm.currentDate; };

    vm.adminViews = new Object();
    vm.adminViews.menuItemTitle = "Views";
    vm.adminViews.menuItemId = "navigationLinks";
    vm.adminViews.menuItemList = [];
    vm.adminViews.menuItemList.push({ title: 'Admin', link: 'home.admin' });
    vm.adminViews.menuItemList.push({ title: 'Data Rights', link: 'home.dataRights' });

    vm.isProfessor = authorizationFactory.authorizeProfessor();

    if (!sessionManagementFactory.isSessionStarted()) {
        sessionManagementFactory.startSession();
    }
}

module.exports = headerController;



//////////////////
// WEBPACK FOOTER
// ./source/angular/components/header/headerController.js
// module id = 55
// module chunks = 0